export default __webpack_public_path__ + "static/media/4093.ec31da27.png";